import React from 'react';
import { List, Typography, Card, Button } from 'antd';
import { SettingFilled, HomeOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
const { Title, Text } = Typography;
const Index = () => {
  const updates = [
    'Online POS Added',
    'Product Base discount added',
    'Sales Report data fetch Fixed',
    'Invoice Delivery Charge, Due amount added',
    'Sold Product Report Column Fixed',
    'Fast POS Added',
    'Payment Report Added',
    'Sold Product Report > Paid Amount Added',
    'POS > Customer search auto number set in Create New Customer ',
    // '',
  ];
  return (
    <Card 
      style={{ maxWidth: 400, margin: 'auto', padding: '20px', borderRadius: '10px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}
      bordered={false}
    >
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <SettingFilled style={{ fontSize: '24px', color: '#1890ff' }} />
        <Title level={4} style={{ margin: '10px 0' }}>Patch Updates</Title>
      </div>
      <List
        dataSource={updates}
        renderItem={(item, index) => (
          <List.Item style={{ borderBottom: 'none', padding: '10px 0' }}>
            <Text strong>
              {index + 1}. {item}
            </Text>
          </List.Item>
        )}
        style={{ textAlign: 'left', marginBottom:"20px" }}
      />
        <Link aria-current="page" to="/dashboard">
            <Button type="danger" icon={<HomeOutlined />}>
                 Go to Dashboard
            </Button>
        </Link>
    </Card>
  );
};
const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};
export default connect(mapStateToProps)(Index);